import React from 'react';
import Tippy from '../../components/ReactTippy';

/**
 * アンカータグを含むリスト
 * @props {string}label:ラベル
 * @props {boolean}isSelected:選択済みにするか？
 * @props {function}onClick:aタグをクリックした時の処理
 */
export class AnchorList extends React.Component {
  constructor(props) {
    super(props);
    if (
      this.props.onClick !== undefined &&
      typeof this.props.onClick === 'function'
    ) {
      this.onClick = this.props.onClick.bind(this);
    } else {
      console.warn('onClick is not function');
    }
  }

  render() {
    const {
      className,
      isSelected,
      label,
      warningIcon,
      warningText,
    } = this.props;
    return (
      <React.Fragment>
        <li className='contruction-navi-list__item'>
          <Tippy
            duration={10}
            distance={24}
            arrow='true'
            arrowType='sharp'
            delay={[50, 100]}
            placement='bottom'
            followCursor={true}
            html={<div className='darklist__tooltip'>{warningText}</div>}
            disable={!warningIcon}
          >
            <a
              className={[
                'line-list line-list--contruction-navi-list',
                isSelected && 'select',
                className,
              ].join(' ')}
              onClick={this.onClick}
            >
              {label}
              {warningIcon}
            </a>
          </Tippy>
        </li>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list/AnchorList.jsx